"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var r = require("revalidate");
var createValidator = r.createValidator;
var composeValidators = r.composeValidators;
var combineValidators = r.combineValidators;
var hasLengthGreaterThan = r.hasLengthGreaterThan;
var isRequired = r.isRequired;
var isAlphabetic = r.isAlphabetic;
var isNumeric = r.isNumeric;
var matchesPattern = r.matchesPattern;
exports.passwordRequired = isRequired({ message: "passwordRequired" });
exports.greaterThanEight = hasLengthGreaterThan(8)({
    message: "needsMoreThanEight"
});
exports.hasCap = matchesPattern(/(.*?[A-Z])/)({ message: "needsUppercase" });
exports.hasLow = matchesPattern(/(.*?[a-z])/)({ message: "needsLowercase" });
exports.hasSpecial = matchesPattern(/(.*?[#?!@$%^&*-])/)({
    message: "needsSpecialCharacter"
});
exports.passwordValidator = composeValidators(exports.passwordRequired, exports.greaterThanEight, exports.hasCap, exports.hasLow, exports.hasSpecial)({ field: "password" });
//# sourceMappingURL=password.js.map


//////////////////
// WEBPACK FOOTER
// ../validation/build/common/password.js
// module id = 437
// module chunks = 22